<template>
    <div class="quickscan-rejected">
        <h1>Aanvraagverzoek</h1>
        <h2>Aanvraag niet mogelijk</h2>

        <quickscan-stepper :current-step="3" :loading="false">
            <p>Op basis van de door u ingevulde gegevens komt u niet in aanmerking voor een aanvraag.</p>

            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn @click="back">Terug</v-btn>
                </v-col>
            </v-row>
        </quickscan-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';

export default {
    name: 'quickscan-rejected',
    components: {
        QuickscanStepper,
    },
    data: () => ({}),
    computed: {
        ...mapGetters(['quickscan']),
    },
    destroyed() {
        // reset error state when navigating away from page
        this.quickscanFinishReset();
    },
    methods: {
        ...mapActions(['quickscanFinishReset']),
        back() {
            this.$router.push({ name: 'quickscan_step2' });
        },
    },
};
</script>
